import {GET_ENTITY_BY_PERMALINK} from "../actions/actionsEntity";

const initialState = {};

export function reducerEntity(state = initialState, action) {
    
    switch (action.type) {
       case GET_ENTITY_BY_PERMALINK:
            return Object.assign({}, state, {
                infoEntity: action.payload.infoEntity,
            });
        default:
            return state
    }
}